<script setup lang="ts">
import { onUnmounted } from "vue";
import { panLeft$, panRight$ } from "@zyzgroup/core-web";
import Box from "./Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const emits = defineEmits<{
  (event: "left", e: HammerInput): void;
  (event: "right", e: HammerInput): void;
}>();

let s1;
let s2;

const mount = (box) => {
  if (!s1) {
    s1 = panLeft$(box.el).subscribe((e) => {
      emits("left", e);
    });
  }
  if (!s2) {
    s2 = panRight$(box.el).subscribe((e) => {
      emits("right", e);
    });
  }
};

onUnmounted(() => {
  s1?.unsubscribe();
  s2?.unsubscribe();
});

defineExpose({});
</script>

<template>
  <Box
    class="pan"
    display-type="empty"
    @mount="mount"
  >
    <slot></slot>
  </Box>
</template>

<style></style>
